import { IFavoriteRecommendationOfferSchema } from '../repositories/favorites/entities/get_favorites_recommendations/FavoriteRecommendationOfferSchema';
import type { TRecommendation } from '../types/recommendation';

export function prepareRecommendations(rawRecommendations: IFavoriteRecommendationOfferSchema[]): TRecommendation[] {
  return rawRecommendations.map(
    ({
      analyticsData,
      dealType,
      discount,
      entityId,
      entityType,
      imageUrl,
      info,
      isFavorite,
      offerType,
      text,
      title,
      underground,
      url,
    }) => ({
      description: text,
      href: url,
      imageUrl: imageUrl || '',
      title,
      transport: info,
      analyticsData,
      offerId: entityId,
      underground,
      isFavorite: isFavorite || false,
      dealType,
      offerType,
      entityType,
      discount,
    }),
  );
}
